import React, { useState } from "react";
import { Textbox } from "../../global/components/inputs/textbox/textbox";
import { IEpiProps, ISearchResult, SearchContext } from "../models/vertex-search-page-models";
import { useVertexSearchContext, useVertexSearchDispatch } from "../reducers/vertex-search-page-provider";

interface IProps {
    searchResult: ISearchResult
}

interface IContextProps {
    epiProps: IEpiProps
    currentSearchContext: string
}

export const SearchResultPrice = (props: IProps) => {
    const { epiProps, currentSearchContext }: IContextProps = useVertexSearchContext();

    let isProduct = props.searchResult.type == "product" || currentSearchContext == SearchContext.ShopAAP;

    if (isProduct &&
        ((props.searchResult.retailPrice && props.searchResult.retailPrice.length > 0) ||
            (props.searchResult.memberPrice && props.searchResult.memberPrice.length > 0)))
    {
        return (
            <div className="search-result-meta">
                {
                    props.searchResult.retailPrice && props.searchResult.retailPrice.length > 0 ?
                        <React.Fragment>
                            <span className="search-result-meta-price">
                                {epiProps.shopSearchResultRetailPriceLabel}
                                <span className="search-result-meta-price-value"> ${props.searchResult.retailPrice}</span>
                            </span>
                        </React.Fragment>
                        : null
                }
                {
                    props.searchResult.retailPrice && props.searchResult.retailPrice.length > 0
                        && props.searchResult.memberPrice && props.searchResult.memberPrice.length > 0 ?
                        <React.Fragment>
                            <span className="middle-dot"> · </span>
                        </React.Fragment>
                        : null
                }
                {
                    props.searchResult.memberPrice && props.searchResult.memberPrice.length > 0 ?
                        <React.Fragment>
                            <span className="search-result-meta-price">
                                {epiProps.shopSearchResultMemberPriceLabel}
                                <span className="search-result-meta-price-value"> ${props.searchResult.memberPrice}</span>
                            </span>
                        </React.Fragment>
                        : null
                }
            </div>
        )
    }
}